// Admission-scoped API calls for the cashless discharge screen rebuild
// (wireframe S5, Insurance Claims Phase 4.5.5) — deposits, the running bill
// and the Main/Breakup bill PDF exports. All already-existing, tested
// endpoints under /api/ip (backend/routes/ip/final-bill.js).
import { api } from '@/lib/api/client';

export interface AdmissionDeposit {
  id: number;
  admission_id: number;
  receipt_no: string;
  amount: string;
  payment_mode: string;
  reference_number: string | null;
  received_by: string | null;
  received_by_user_id: number | null;
  branch_id: number;
  received_at: string;
  adjusted_bill_id: number | null;
  refunded_credit_note_id: number | null;
}

export interface IpRunningBillHead {
  head: string;
  gross: number;
  discount: number;
  gst: number;
  net: number;
  payer_amount: number;
  patient_amount: number;
}

export interface IpRunningBill {
  admission_id: number;
  generated_at: string;
  heads: IpRunningBillHead[];
  gross: number;
  discount: number;
  gst: number;
  net: number;
  payerTotal: number;
  patientTotal: number;
  invoiceIds: number[];
}

export function fetchAdmissionDeposits(admissionId: number): Promise<AdmissionDeposit[]> {
  return api.get(`/ip/admissions/${admissionId}/deposits`);
}

export function createAdmissionDeposit(
  admissionId: number, input: { amount: number; payment_mode: 'Cash' | 'UPI' | 'Card'; reference_number?: string }
): Promise<AdmissionDeposit> {
  return api.post(`/ip/admissions/${admissionId}/deposits`, input);
}

export function fetchIpRunningBill(admissionId: number): Promise<IpRunningBill> {
  return api.get(`/ip/admissions/${admissionId}/running-bill`);
}

export function generateProvisionalStatement(admissionId: number): Promise<{ id: number; statement_no: string }> {
  return api.post(`/ip/admissions/${admissionId}/final-bill/provisional`, {});
}

export interface FinalBillExportsResult {
  final_bill_id: number;
  main_document_id: number;
  breakup_document_id: number;
  content_hash: string;
}

export function generateFinalBillExports(admissionId: number): Promise<FinalBillExportsResult> {
  return api.post(`/ip/admissions/${admissionId}/final-bill-exports`, {});
}
